import Vue from 'vue';
import router from './plugins/router';
import store from './plugins/vuex';
import vuetify from './plugins/vuetify';
import Application from './Application.vue';

Vue.config.productionTip = false;

const app = new Vue({ router, store, vuetify, render: h => h(Application) });
app.$mount('#app');
